<div class="container-fluid">
  <div class="d-flex gap-1 mt-2">

    <app-searchable-select
      class="col-md-3"
      [options]="counsellors$ | async"
      [multiple]="true"
      [hideSelectAllOption]="false"
      [selectedValue]="submittedBy"
      (selectionChange)="submittedBy = $event"
      [displayKey]="'userName'"
      [valueKey]="'userName'"
      [label]="'Counsellor Name'"
      [placeholder]="'All Counsellors'"
    ></app-searchable-select>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>&nbsp;

    <button mat-mini-fab color="accent" (click)="onSearch()" matTooltip="Search">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="onClear()" matTooltip="Clear Filters">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Counselling Observation List</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary" (click)="openIndividualSessionDialog()"
                permission="Counselling Observation"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">
    <ng-container matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef > Sr. No.</th>
      <td mat-cell *matCellDef="let i = index"> {{i+1}} </td>
    </ng-container>

    <ng-container matColumnDef="sessionDate">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let row"> {{ row?.sessionDate.toDate() | date }} </td>
    </ng-container>

    <ng-container matColumnDef="counsellor">
      <th mat-header-cell *matHeaderCellDef> Counsellor </th>
      <td mat-cell *matCellDef="let row"> {{ row?.counsellor }} </td>
    </ng-container>

    <ng-container matColumnDef="observedBy">
      <th mat-header-cell *matHeaderCellDef> Observed By </th>
      <td mat-cell *matCellDef="let row"> {{ row?.observedBy }} </td>
    </ng-container>

    <ng-container matColumnDef="counsellingSkills">
      <th mat-header-cell *matHeaderCellDef> Skills </th>
      <td mat-cell *matCellDef="let row"> {{ row.counsellingSkills }} </td>
    </ng-container>

    <ng-container matColumnDef="interventions">
      <th mat-header-cell *matHeaderCellDef> Interventions </th>
      <td mat-cell *matCellDef="let row"> {{ row?.interventions }} </td>
    </ng-container>

    <ng-container matColumnDef="understandingOfProblem">
      <th mat-header-cell *matHeaderCellDef> Understanding </th>
      <td mat-cell *matCellDef="let row"> {{ row?.understandingOfProblem }} </td>
    </ng-container>

    <ng-container matColumnDef="homeProgram">
      <th mat-header-cell *matHeaderCellDef> Home Program </th>
      <td mat-cell *matCellDef="let row"> {{ row?.homeProgram }} </td>
    </ng-container>

    <ng-container matColumnDef="feedback">
      <th mat-header-cell *matHeaderCellDef> Feedback </th>
      <td mat-cell *matCellDef="let row">
    <span matTooltip="{{ row?.feedback }}" matTooltipPosition="above">
      {{ row?.feedback?.length > 10 ? (row?.feedback | slice:0:10) + '...' : row?.feedback }}
    </span>
      </td>
    </ng-container>


    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row" class="action-buttons">
        <button mat-icon-button color="primary" permission="Counselling Observation" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" (click)="viewServicingDetails(row)" matTooltip="View"><mat-icon>visibility</mat-icon></button>
        <button mat-icon-button color="primary" permission="Counselling Observation" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" (click)="viewEdit(row)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button color="warn"  permission="Counselling Observation" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]" (click)="delete(row.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" colspan="10"> No data found</td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
</div>
